import type { PluginMcpServer } from '@crowdex/plugin-contracts';
import { useEffect, useState } from 'react';
import { isLocalMachine } from '@/lib/local-runtime';
import { nativePluginClient } from '@/lib/plugins/plugin-native-client';

/**
 * The MCP servers contributed by the currently enabled plugins, for the
 * composer's MCP submenu. Uses the same source of truth as the session
 * installed-plugin catalog. Fetched once per mount (the menu remounts
 * each time it opens) so it reflects the latest enabled/disabled state without
 * threading extra props through the shell. Empty in the browser preview / cloud
 * where no native plugins exist.
 */
export function useEnabledMcpServers(): readonly PluginMcpServer[] {
  const [servers, setServers] = useState<readonly PluginMcpServer[]>([]);
  useEffect(() => {
    if (!isLocalMachine()) return;
    let cancelled = false;
    void nativePluginClient
      .list()
      .then((plugins) => {
        if (!cancelled) {
          setServers(plugins.flatMap((plugin) => (plugin.enabled ? plugin.mcpServers : [])));
        }
      })
      .catch(() => {
        if (!cancelled) setServers([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return servers;
}
